module.exports = __webpack_public_path__ + "img/WeatherStation.bdd0b765.png";